import React from 'react';

import {
  Button,
  Group,
  Paper,
  Stack,
  Title
} from '@mantine/core';
import { useNavigate, useParams } from 'react-router-dom';

import CareManagerForm from '../components/caremanager/CareManagerForm';
import type { CareManager } from '../components/caremanager/types';
import ErrorState from '../components/state/ErrorState';
import LoadingState from '../components/state/LoadingState';
import { usePostJSON } from '../utils/request';

interface CareManagerResponse {
  success: boolean;
  careManager: CareManager;
}

const EditCareManager: React.FC = () => {
  const { id: _id } = useParams<{ id: string }>();
  const id = _id ? parseInt(_id, 10) : undefined;
  const navigate = useNavigate();

  const { data, error, loading } = usePostJSON<CareManagerResponse>(
    '/api/care_manager/data_one',
    { id },
    [id]
  );

  const careManager = data?.careManager || null;

  if (!id) {
    return <ErrorState message="Invalid care manager ID" title="Error" />;
  }
  if (loading) {
    return <LoadingState message="Loading care manager data..." style={{ height: '50vh' }} />;
  }
  if (error) {
    return <ErrorState message={error.message} title="Error" />;
  }
  if (!careManager) {
    return <ErrorState message="Care manager not found" title="Not Found" />;
  }

  const handleSuccess = () => {
    void navigate('/care_managers');
  };

  return (
    <Stack gap="md">
      <Group align="center" justify="space-between">
        <Title order={1}>Edit Care Manager — {careManager.firstName} {careManager.lastName}</Title>
        <Button variant="outline" onClick={() => void navigate('/care_managers')}>
          Back to All Care Managers
        </Button>
      </Group>

      <Paper withBorder p="xl">
        <CareManagerForm
          initialData={careManager}
          mode="edit"
          onCancel={() => void navigate('/care_managers')}
          onSuccess={handleSuccess}
        />
      </Paper>
    </Stack>
  );
};

export default EditCareManager;
